<template>
    <div class="survey-display-item">
        <ConversationItemSay
            v-if="
                surveyNode.type === 'Say' &&
                surveyNode.cardType !== TYPE_REVIEW_LINK_BUTTON &&
                surveyNode.aiConversationalMode !== true
            "
            :message="surveyNode.value"
            :survey-display-values="surveyDisplayValues"
            :survey-params="surveyParams"
            :avatar-src="avatarSrc"
            :is-active="isActive"
            :is-followed-by-input="isFollowedByInput"
            :csat-labels="props.csatLabels"
            @callNext="handleNextNode"
            @updateScore="handleUpdateScore"
        />
        <ConversationItemSayAI
            v-if="
                surveyNode.type === 'Say' &&
                surveyNode.cardType !== TYPE_REVIEW_LINK_BUTTON &&
                surveyNode.aiConversationalMode === true
            "
            :item="surveyNode"
            :survey-display-values="surveyDisplayValues"
            :survey-params="surveyParams"
            :survey-questions-and-answers="surveyQuestionsAndAnswers"
            :avatar-src="avatarSrc"
            :is-active="isActive"
            :is-preview="isPreview"
            @callNext="handleNextNode"
            @saveAiQuestion="saveAiQuestion"
        />
        <ConversationItemReviewLink
            v-if="
                surveyNode.type === 'ReceiveText' &&
                surveyNode.param === TYPE_REVIEW_LINK_BUTTON
            "
            :item="surveyNode"
            :survey-display-values="surveyDisplayValues"
            :slug="props.surveyParams.slug"
            @callNext="handleNextNode"
        />
        <ConversationItemReceiveOption
            v-if="surveyNode.type === 'ReceiveOption' && !surveyNode.link"
            :item="surveyNode"
            :survey-display-values="surveyDisplayValues"
            :survey-params="surveyParams"
            :option-labels="optionLabels"
            @callNext="handleNextNode"
        />
        <ConversationItemCalendly
            v-if="surveyNode.type === 'ReceiveOption' && surveyNode.link"
            :item="surveyNode"
            :survey-spec="surveySpec"
            :survey-display-values="surveyDisplayValues"
            @callNext="handleNextNode"
        />
        <ConversationItemReceiveText
            v-if="
                surveyNode.type === 'ReceiveText' &&
                surveyNode.param !== TYPE_REVIEW_LINK_BUTTON
            "
            :item="surveyNode"
            :survey-display-values="surveyDisplayValues"
            @callNext="handleNextNode"
        />
    </div>
</template>

<script setup lang="ts">
import {
    ConversationItem,
    ConversationSpec,
    CurrentAnswer,
    Options,
    SurveyDisplayValues,
    SurveyParams,
    TYPE_REVIEW_LINK_BUTTON,
    OptionLabels,
} from '@/entities/conversation'
import ConversationItemSay from './ConversationItemSay.vue'
import ConversationItemSayAI from './ConversationItemSayAI.vue'
import ConversationItemReviewLink from './ConversationItemReviewLink.vue'
import ConversationItemReceiveOption from './ConversationItemReceiveOption.vue'
import ConversationItemCalendly from './ConversationItemCalendly.vue'
import ConversationItemReceiveText from './ConversationItemReceiveText.vue'
import { getCDNUrl } from '@/utils/cdn'

interface Props {
    surveyNode: ConversationItem
    surveyDisplayValues?: SurveyDisplayValues
    surveyParams: SurveyParams
    surveyQuestionsAndAnswers: CurrentAnswer[]
    isActive: boolean
    isFollowedByInput?: boolean
    surveySpec: ConversationSpec
    csatLabels: Options
    isPreview: boolean
    optionLabels: OptionLabels | null
}

const props = defineProps<Props>()
const emit = defineEmits(['nextNode', 'updateScore', 'saveAiQuestion'])

const avatarSrc = getCDNUrl(props.surveyParams.avatar)

const handleNextNode = (newValue = null, answerString = null) => {
    emit('nextNode', newValue, answerString)
}

const handleUpdateScore = (data) => {
    emit('updateScore', data)
}

const saveAiQuestion = (
    aiQuestion = null,
    aiAnswer = null,
    aiQuestionIndex = 1
) => {
    emit('saveAiQuestion', aiQuestion, aiAnswer, aiQuestionIndex)
}

if (
    props.surveyNode.type === 'Say' &&
    props.surveyNode.cardType === TYPE_REVIEW_LINK_BUTTON
) {
    handleNextNode()
}
</script>

<style lang="less">
.survey-display-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}
</style>
